import { defineMessages } from '@/i18n'

export const messages = defineMessages({
  ru: {
    // buyFailureText
    buyFailed: 'Не удалось начать оплату',
    packageGone: 'Этот пакет больше не доступен',
    emailRequired: 'Для оплаты картой нужен email в профиле — выберите другой способ',
    // historyRow
    opPurchase: 'Пополнение',
    opBonus: 'Начисление студии',
    opRefund: 'Возврат',
    opCharge: 'Списание',
    opUnknown: 'Операция',
    // paymentHistoryRow
    statusInitialized: 'Ожидает оплаты',
    statusCompleted: 'Оплачен',
    statusCanceled: 'Отменён',
    statusFailed: 'Отклонён',
    statusRefunded: 'Возвращён',
    statusGifted: 'Подарок',
    // paymentMethods
    methodRussianCard: 'Российская карта',
    methodCrypto: 'Криптовалютой',
  },
  en: {
    buyFailed: 'Couldn’t start the payment',
    packageGone: 'This package is no longer available',
    emailRequired: 'Paying by card requires an email in your profile — choose another method',
    opPurchase: 'Top-up',
    opBonus: 'Studio bonus',
    opRefund: 'Refund',
    opCharge: 'Charge',
    opUnknown: 'Transaction',
    statusInitialized: 'Awaiting payment',
    statusCompleted: 'Paid',
    statusCanceled: 'Cancelled',
    statusFailed: 'Declined',
    statusRefunded: 'Refunded',
    statusGifted: 'Gift',
    methodRussianCard: 'Russian card',
    methodCrypto: 'Crypto',
  },
})
